$(document).ready(function() {
    $(".zoomable").elevateZoom({
          zoomWindowPosition: "imageZoom", // Position for the zoom window
            showLens: true,
            easing : true,
            borderSize: 0,
           responsive: true,
           scrollZoom: true
      });
  
 
$(document).on('click', '.product_wrapper-addon', function(event) {
    var productId = $(this).data('product-id');
  if ($(window).width() < 740) {
        // Prevent click only if it's on an image inside product_wrapper-addon
        if ($(event.target).is('img.zoomable')) {
            event.stopPropagation(); // Stops click event from bubbling up
            return false; // Prevent default action
        }
    }  
    if($(this).hasClass('default-prod-jtpl')==true){
       var limit = $(this).attr("data-limit");
    $("input.matching-product-qty.quantity").attr("data-limit",limit);
   
    }
  //  $(this).find(".variant_wrapper-addon").removeClass("active-wrapper");
  //  $(this).find(".variant_wrapper-addon .variants-addon ").removeClass("active-variant");
  // $(this).find(".right_wrapper .price_quan_wrapper").removeClass("quan-active-wrapper");
  //  $(this).find(".right_wrapper .variant_wrapper-addon.variant-addon-" + productId).addClass("active-wrapper");
  //  $(this).find(".right_wrapper .price_quan_wrapper").addClass("quan-active-wrapper");
   //  if ($(this).hasClass('active')) {
   //    // If it already has the 'active' class, remove it
   //    $(this).removeClass('active');
   //   // $(".variant_wrapper-addon").css('display', 'none'); // Hide all variant wrappers
   //    $(".variant_wrapper-addon").removeClass("active-wrapper"); 
   //    $(".right_wrapper .price_quan_wrapper").removeClass("quan-active-wrapper");
     
   //  } else{
   //        $('.product_wrapper-addon').removeClass('active');
   //    $(this).addClass('active');
   // // $('.variant_wrapper-addon').hide();
   // // $('.variant_wrapper-addon.variant-addon-'+productId).show(); 
   //  }
    
  });



  
  $(document).on('click', '.variants-addon', function() {
   var limit = $(this).attr("data-limit");
    console.log(limit);
      $(this).closest('.right_wrapper').find('input.matching-product-qty.quantity').attr("data-limit", limit);
  //  // $('.active-wrapper').find('.matching_quantity').css('display', 'none').removeClass('match-quan');
  // $(".variant_wrapper-addon").removeClass("active-wrapper");
  //   var upsell_variant_id = $(this).data('variant-id');
  //    $(this).parents(".variant_wrapper-addon").addClass("active-wrapper");
    if ($(this).hasClass('active-variant')) {
       $(".variant_wrapper-addon .variants-addon ").removeClass("active-variant");
    }
    
    $(this).addClass('active-variant').siblings().removeClass('active-variant');
    $(this).parent('.variant_wrapper-addon').addClass('active-wrapper').siblings().removeClass('active-wrapper');
     var productWrapper = $(this).closest('.product_wrapper-addon');
    productWrapper.addClass('active'); // Add the 'active' class to the product wrapper
    productWrapper.find(".right_wrapper .price_quan_wrapper").addClass("quan-active-wrapper"); 
   // console.log(upsell_variant_id);
  });

// Increase quantity when the "+" button (match-variant-up) is clicked
$(".match-variant-up").click(function() {
    var quantityInput = $(this).siblings("input.matching-product-qty"); // Get the sibling input field
    var currentValue = parseInt(quantityInput.val()); // Get the current value as an integer
  
    var maxLimit = parseInt(quantityInput.attr("data-limit")); // Get the max limit value from the data attribute

       quantityInput.val(currentValue + 1); // Increase the value by 1
    
   
});

// Decrease quantity when the "-" button (match-variant-down) is clicked
$(".match-variant-down").click(function() {
    var quantityInput = $(this).siblings("input.matching-product-qty"); // Get the sibling input field
    var currentValue = parseInt(quantityInput.val()); // Get the current value as an integer

    // Decrease the value only if it's greater than the min value
    if (currentValue > 1) {
        quantityInput.val(currentValue - 1); // Decrease the value by 1
    }
});

});

// document.addEventListener("DOMContentLoaded", function () {
//   if($(".product-qty.quantity").length > 0){
//     const element = document.querySelector(".product-qty.quantity");
//     if (element) {
//         element.addEventListener("change", function (event) {
//          var qty = element.value;
//           if(qty < 1){
//             element.value = 1;
//             event.preventDefault();
//             return false;
//           }
//         });
//     }
//   }
// });
document.addEventListener("DOMContentLoaded", function () {
  if ($(".product-qty.quantity").length > 0) {
    const element = document.querySelector(".product-qty.quantity");
    if (element) {
      // Prevent typing '0' in the input field
      element.addEventListener("keydown", function (event) {
        // If the user presses the '0' key and the value is empty, prevent it
        if (event.key === '0' && element.value === '') {
          event.preventDefault();
        }
      });

      element.addEventListener("input", function (event) {
        let qty = parseInt(element.value);
        
        // If the value is less than 1, reset it to 1
        if (qty < 1 || isNaN(qty)) {
          element.value = 1;
        }
      });

      // You can also enforce it when the user changes the quantity via up/down buttons
      element.addEventListener("change", function (event) {
        var qty = parseInt(element.value);
        if (qty < 1 || isNaN(qty)) {
          element.value = 1;
          event.preventDefault();
        }
      });
    }
  }
});

